import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormikInput } from 'components/UiKit/FormikFields';

import { useFormikContext } from 'formik';

const CropZoneNameInput = ({ name = '' }) => {
  const { setFieldValue } = useFormikContext();

  useEffect(() => {
    setFieldValue('name', name);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name]);

  return <FormikInput name="name" label="Crop Zone Name*" />;
};

CropZoneNameInput.propTypes = {
  name: PropTypes.string
};

export default CropZoneNameInput;
